class UserModel {
    firstName!: string;
    middleName!: string;
    lastName?: string;
    email!: string;
    password!: string;
  }
  
  export default UserModel;